import type { ReactNode } from 'react';
import { Alert } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '../hooks/usePermissions';
import { pagePermission } from '../utils/pagePermissions';

export default function ModuleAccess({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { hasPermission } = usePermissions();
  const { t } = useTranslation();
  const permission = pagePermission(location.pathname, location.search);
  if (permission && !hasPermission(permission)) return <Alert severity="warning">{t('errorHandling.forbidden.message')}</Alert>;
  return <>{children}</>;
}
